import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout'
import SiteSettings from './MobileSettings'
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

async function action({ store, intl }) {
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account && store.getState().account.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
    const adminId = store?.getState()?.account?.id;
    const isDemoRestricted = store?.getState()?.siteSettings?.data?.isDemoRestricted;

    if (!isAdminAuthenticated) return { redirect: '/login' };
    if (!restrictUrls('/siteadmin/settings/mobile-app', adminPrivileges, privileges)) return { redirect: '/siteadmin' };

    return {
        title: intl.formatMessage(messages.mobileSettings),
        component: <AdminLayout><SiteSettings adminId={adminId} isDemoRestricted={isDemoRestricted} /></AdminLayout>
    };
}

export default action